export const datePickerTheme = {
  panel: {
    padding: 'var(--half-rem)',
    borderRadius: 'var(--border-radius)',
  },
  colorScheme: {
    light: {
      panel: {
        background: 'var(--white)',
        shadow: 'var(--overlay-box-shadow)',
        borderColor: 'var(--transparent)',
      },
      dropdown: {
        background: 'var(--p-primary-500)',
        color: 'var(--white)',
        borderColor: 'var(--p-primary-500)',
        hoverBackground: 'var(--p-primary-600)',
        hoverColor: 'var(--white)',
        hoverBorderColor: 'var(--p-primary-600)',
        activeBackground: 'var(--p-primary-600)',
        activeColor: 'var(--white)',
        activeBorderColor: 'var(--p-primary-600)',
      },
    },
    dark: {
      panel: {
        background: 'var(--secondary-background)',
        shadow: 'var(--overlay-box-shadow)',
        borderColor: 'var(--transparent)',
      },
      dropdown: {
        background: 'var(--p-primary-500)',
        color: 'var(--p-white)',
        borderColor: 'var(--p-primary-500)',
        hoverBackground: 'var(--p-primary-600)',
        hoverColor: 'var(--p-white)',
        hoverBorderColor: 'var(--p-primary-600)',
        activeBackground: 'var(--p-primary-600)',
        activeColor: 'var(--p-white)',
        activeBorderColor: 'var(--p-primary-600)',
      },
    },
  },
};
